// Turks (tr-TR), family: zelfde vorm als family.nl.ts. Wat ontbreekt valt terug op het Nederlands
// (nooit een rauwe sleutel op het scherm). Menunamen van Nederlandstalige apps (Parro, Magister,
// Voetbal.nl) blijven in het Nederlands: zo staan ze ook in die apps.
export const familyTr = {
    nav: {
        wishes: 'Dilekler',
        messages: 'Mesajlar',
        calendars: 'Takvimler',
        family: 'Akrabalar',
    },
    common: {
        save: 'Kaydet',
        saved: 'Kaydedildi.',
        add: 'Ekle',
        edit: 'Düzenle',
        remove: 'Kaldır',
        undo: 'Geri al',
        copy: 'Bağlantıyı kopyala',
        copied: 'Bağlantı kopyalandı.',
        readOnly: 'Sadece okunur',
        everyone: 'Herkes',
        loading: 'Yükleniyor…',
        retry: 'Tekrar dene',
        error: 'Bir şeyler ters gitti. Tekrar dene.',
        back: 'Geri',
        close: 'Kapat',
        whoAreYou: 'Sen kimsin?',
        readAloud: 'Sesli oku',
        inDays: { one: 'yarın', other: '{count} gün sonra' },
        today: 'bugün',
        turnsAge: '{age} yaşına giriyor',
        dayOf: 'gün {index}/{count}',
    },
    wishes: {
        title: 'Dilekler',
        intro: 'Dilek listelerinde neler var? Çocuklar tablette kendileri bir resim seçer.',
        add: 'Dilek ekle',
        addShort: 'Dilek',
        listOf: 'Dilekler: {name}',
        editTitle: 'Dileği düzenle',
        newTitle: 'Yeni dilek',
        fieldTitle: 'Ne istiyor?',
        fieldTitleHint: 'Kısa ve net, örneğin Denge bisikleti',
        fieldFor: 'Kimin için',
        fieldPicto: 'Resim',
        fieldNote: 'Açıklama',
        fieldNoteHint: 'Beden, renk ya da marka (isteğe bağlı)',
        fieldUrl: 'Mağaza bağlantısı',
        fieldUrlHint: 'https:// ile başlar (isteğe bağlı)',
        fieldPrice: 'Yaklaşık (€)',
        fieldPriority: 'Ne kadar istiyor?',
        priority1: 'Güzel olur',
        priority2: 'Çok güzel olur',
        priority3: 'En çok istediğim',
        received: 'Alındı',
        markReceived: 'Alındı',
        fromTablet: 'tablette kendisi seçti: tam olarak neyi birlikte seçin',
        removed: '{title} kaldırıldı.',
        receivedToast: '{title} alınanlar arasında.',
        share: 'Paylaş',
        shareTitle: 'Listeyi paylaş: {name}',
        shareIntro: 'Bu bağlantıya sahip herkes listeyi görebilir ve hesap olmadan bir şeyi işaretleyebilir. {name} kimin ne aldığını asla görmez.',
        shareCreate: 'Paylaşım bağlantısı oluştur',
        shareNew: 'Yeni bağlantı',
        shareNewHint: 'Eski bağlantı bundan sonra çalışmaz.',
        shareStop: 'Paylaşmayı durdur',
        shareStopped: 'Liste artık paylaşılmıyor.',
        shared: 'Paylaşıldı',
        reveal: 'Göster',
        revealHint: 'Neyin alındığını gösterir. Dikkat: çocuklar da görebilir.',
        claimedBy: '{name} bunu alıyor',
        claimedAnon: 'Biri bunu alıyor',
        boughtBy: '{name} bunu aldı',
        boughtAnon: 'Zaten alındı',
        emptyTitle: 'Henüz dilek yok',
        emptyBody: 'Bir tane ekle ya da tablette seçsin: {name}.',
        urlInvalid: 'https:// ile başlayan bir bağlantı kullan',
    },
    share: {
        title: 'Dilek listesi: {name}',
        intro: 'Hediye etmek için bir şey seç. {name} kimin ne aldığını görmez.',
        claim: 'Bunu ben alırım',
        claimTitle: 'Bu hediyeyi sen al',
        claimName: 'Adın (isteğe bağlı)',
        claimNameHint: 'Başkaları bunun ayarlandığını görsün diye.',
        claimConfirm: 'Bunu ben alırım',
        mine: 'Bunu sen alıyorsun',
        mineBought: 'Bunu sen aldın',
        bought: 'Alındı',
        release: 'Vazgeçtim',
        taken: 'Bunu zaten biri alıyor',
        takenBy: '{name} bunu zaten alıyor',
        goneTitle: 'Bu bağlantı artık çalışmıyor',
        goneBody: 'Yeni bir bağlantı iste.',
        emptyTitle: 'Liste henüz boş',
        emptyBody: 'Daha sonra tekrar bak.',
        footer: 'AMUMIN aile panosuyla yapıldı. Hesap gerekmez.',
        toWebshop: 'Mağazada gör',
    },
    days: {
        title: 'Takvimler',
        intro: 'Doğum günleri, bayramlar, okul tatilleri ve bağlı takvimler kendiliğinden takvimde görünür.',
        upcoming: 'Yakında',
        upcomingEmpty: 'Önümüzdeki haftalarda özel bir şey yok.',
        layers: 'Takvimde neler var?',
        layerBirthdays: 'Doğum günleri',
        layerBirthdaysHint: 'Ailenin ve doğum günlerini paylaşan ailelerin.',
        layerHolidays: 'Resmî tatiller',
        layerHolidaysHint: 'Kral Günü, Paskalya, Noel ve Anneler Günü gibi günler.',
        layerSchool: 'Okul tatilleri',
        region: 'Bölge',
        regionNoord: 'Kuzey',
        regionMidden: 'Orta',
        regionZuid: 'Güney',
        regionOff: 'Kapalı',
        regionHint: 'Çocukların okulu hangi bölgede? Sonbahar, Noel, bahar ve mayıs tatilleri tavsiye edilen tarihlerdir.',
        birthdays: 'Doğum günleri',
        birthdaysHint: 'Bir doğum tarihi gir, doğum günü takvimde görünsün.',
        birthDate: 'Doğum tarihi: {name}',
        birthDateSaved: 'Doğum günü takvimde: {name}.',
    },
    feeds: {
        title: 'Bağlı takvimler',
        add: 'Takvim bağla',
        addTitle: 'Takvim bağla',
        intro: 'Okul, spor ve iş takvimlerini otomatik al. Yarım saatte bir güncellenir.',
        provider: 'Takvim nereden geliyor?',
        providers: {
            google: 'Google',
            icloud: 'iCloud',
            outlook: 'Outlook',
            parro: 'Parro',
            magister: 'Magister',
            sportlink: 'Sportlink',
            other: 'Diğer',
        },
        howto: {
            google: 'Takvim ayarları → Takvimi entegre et → iCal biçimindeki gizli adres.',
            icloud: 'Takvim → takvimi paylaş → Herkese Açık Takvim → webcal bağlantısını kopyala.',
            outlook: 'Ayarlar → Takvim → Paylaşılan takvimler → Yayımla → ICS bağlantısı.',
            parro: 'Parro → Instellingen → Agenda koppelen → bağlantıyı kopyala.',
            magister: 'Magister → Agenda → Agenda delen → bağlantıyı kopyala.',
            sportlink: 'Voetbal.nl → Programma → Zet in je agenda → iCal bağlantısını kopyala.',
            other: '.ics ile biten ya da webcal:// ile başlayan her bağlantı çalışır.',
        },
        url: 'Bağlantı',
        urlHint: 'webcal:// ya da https:// ile başlar',
        name: 'Ad',
        namePlaceholder: 'Örneğin Okul',
        forWho: 'Kimin için',
        forWhoHint: 'Kimse seçilmezse herkes için.',
        review: 'Bilinmeyenleri önce göster',
        reviewHint: 'Birden fazla çocuk için tek bir okul takvimi varsa kullanışlı.',
        rules: 'Kurallar',
        rulesHint: 'Başlıkta bu mu geçiyor? O zaman şu kişiye ait…',
        ruleContains: 'Metin',
        rulePlaceholder: 'örneğin 3. sınıf',
        addRule: 'Kural ekle',
        connect: 'Bağla',
        connected: '{name} bağlandı: {count} etkinlik.',
        refresh: 'Şimdi yenile',
        refreshed: 'Güncellendi.',
        remove: 'Bağlantıyı kes',
        removeConfirm: '{name} takviminin bağlantısı kesilsin mi? Ondan gelen etkinlikler takviminden kalkar.',
        removed: '{name} bağlantısı kesildi.',
        statusOk: 'Güncellendi {ago}',
        statusNew: 'Henüz alınmadı',
        statusStale: 'Eski: bir gündür ulaşılamıyor',
        statusError: 'Olmadı: {error}',
        items: { one: '{count} etkinlik', other: '{count} etkinlik' },
        reviewCount: 'Bilinmeyen ({count})',
        reviewTitle: 'Bu kimin için?',
        reviewIntro: 'Her etkinlik için kimin olduğunu seç. Yenilemeden sonra da böyle kalır.',
        hide: 'Gizle',
        assign: 'Ata',
        readonlyNote: 'Başlık ve saat bağlı takvimden gelir.',
        emptyTitle: 'Henüz bağlı takvim yok',
        emptyBody: 'Okul, spor ve iş takvimlerini otomatik al.',
    },
    links: {
        title: 'Akrabalar ve arkadaşlar',
        intro: 'Dede ve nineyi, diğer ebeveyni ya da arkadaşları bağla. Neyi paylaşacağını kendin seçersin.',
        add: 'Akraba bağla',
        addTitle: 'Akraba bağla',
        codeHave: 'Kod mu aldın?',
        codePlaceholder: 'ABCD-EFGH',
        codeView: 'Göz at',
        kind: 'Kim?',
        kinds: {
            grandparents: 'Dede ve nine',
            coparent: 'Diğer ebeveyn',
            family: 'Akraba',
            friends: 'Arkadaşlar',
        },
        label: 'Onlara ne diyorsunuz?',
        labelPlaceholder: 'Örneğin Dede ve Nine Yılmaz',
        via: 'Nasıl davet edilsin?',
        viaEmail: 'E-postayla',
        viaCode: 'Kodla',
        email: 'E-posta adresi',
        share: 'Neyi paylaşıyorsun?',
        scopeAgenda: 'Kimin takvimi',
        scopeAgendaHint: 'Sadece seçtiğin çocukların etkinlikleri.',
        scopeBirthdays: 'Doğum günleri',
        scopeWishlists: 'Dilek listeleri',
        scopeContact: 'İletişim bilgileri',
        scopeMessages: 'Mesajlar',
        scopeMessagesHint: 'Onları eklediğin sohbetlere katılabilirler.',
        invite: 'Davet et',
        invited: 'Davet gönderildi: {email}.',
        codeReady: 'Bu kodu ver: {label}',
        codeValid: '{date} tarihine kadar geçerli. Onlar kodu Akrabalar → Kod mu aldın? bölümüne girer.',
        weShare: 'Bizim paylaştıklarımız',
        theyShare: 'Onların paylaştıkları',
        nothing: 'henüz hiçbir şey',
        statusPending: 'davet edildi',
        statusActive: 'bağlı',
        statusRevoked: 'bağlantı kesildi',
        statusEnded: 'bağlantıyı onlar kesti',
        expires: 'bitiş {date}',
        view: 'Göz at',
        adjust: 'Değiştir',
        revoke: 'Bağlantıyı kes',
        revokeInvite: 'Geri çek',
        remove: 'Sil',
        guestMoreDays: '{count} gün daha göster',
        endedHint: 'Bağlantıyı onlar durdurdu. Buradan kaldır; yeniden bağlanmak her zaman mümkün.',
        revokeConfirm: 'Bu bağlantı kesilsin mi: {label}? Bundan sonra birbirinizden hiçbir şey görmezsiniz.',
        revoked: 'Bağlantı kesildi.',
        previewTitle: '{name} bağlanmak istiyor',
        previewShares: 'Ailenle paylaştıkları:',
        accept: 'Bağlan',
        accepted: '{name} ile bağlantı kuruldu. Karşılığında neyi paylaşacağını aşağıdan seç.',
        acceptLabel: 'Onlara ne diyorsunuz?',
        inviteGone: 'Bu davet yok, artık geçerli değil ya da zaten kullanılmış.',
        linkGoneTitle: 'Bu bağlantı artık çalışmıyor',
        linkGoneBody: 'Yeni bir kod iste ya da kodu aşağıya yaz.',
        toFamily: 'Akrabalara git',
        emailMismatch: 'Bu davet başka bir e-posta adresi için.',
        alreadyLinked: 'Zaten bağlısınız.',
        contactTitle: 'İletişim kartımız',
        contactHint: 'Sadece iletişim bilgilerini paylaştığın aileler görür.',
        address: 'Adres',
        phone: 'Telefon',
        contactEmail: 'E-posta',
        note: 'Not',
        emptyTitle: 'Henüz bağlı kimse yok',
        emptyBody: 'Dede ve nineyi bağla: doğum günlerini ve dilekleri görürler, mesaj da gönderebilirler.',
        guestTitle: '{name}',
        guestNothing: 'Henüz hiçbir şey paylaşılmadı',
        guestNothingBody: 'Neyi göstereceklerini kendileri seçer.',
        guestAgenda: 'Takvim (14 gün)',
        guestBirthdays: 'Yakında doğum günü',
        guestWishes: 'Dilekler',
        guestContact: 'İletişim',
        guestNoEvents: 'Önümüzdeki iki haftada etkinlik yok.',
    },
    messages: {
        title: 'Mesajlar',
        intro: 'Güvenli: sadece ailen ve senin bağladığın aileler. Reklam yok, algoritma yok.',
        parentsReadAll: 'Ebeveynler çocukların sohbetleri dahil tüm sohbetleri okuyabilir.',
        family: 'Aile',
        add: 'Sohbet',
        addTitle: 'Yeni sohbet',
        fieldTitle: 'Sohbetin adı',
        fieldTitlePlaceholder: 'Örneğin Dede ve nine',
        fieldWho: 'Kimler katılıyor?',
        fieldLinks: 'Bağlı aileler',
        fieldLinksHint: 'Sadece mesajlarını paylaştığın aileler.',
        create: 'Sohbet oluştur',
        placeholder: 'Bir mesaj yaz…',
        send: 'Gönder',
        stickers: 'Çıkartmalar',
        record: 'Sesli mesaj',
        recording: 'Kaydediyor… durdurmak için dokun',
        voice: 'Sesli mesaj',
        play: 'Oynat',
        hidden: 'Mesaj bir ebeveyn tarafından gizlendi',
        hide: 'Gizle',
        fromLinked: 'Bağlı ailelerden',
        pickConversation: 'Bir sohbet seç',
        emptyTitle: 'Henüz mesaj yok',
        emptyBody: 'Aile sohbetinde başla.',
        kidEmptyBody: 'Bir çıkartma gönder!',
        newMessages: 'yeni mesajlar',
        noMember: 'Mesaj göndermek için önce hesabını bir aile üyesine bağla.',
        sticker: 'Çıkartma',
    },
    phrase: {
        love: 'Seni seviyorum',
        comeHome: 'Eve geliyor musun?',
        hungry: 'Acıktım',
        done: 'Bitti!',
        miss: 'Seni özledim',
        play: 'Oynayalım mı?',
    },
    wishPicto: {
        gift: 'Hediye',
        play: 'Peluş',
        puzzle: 'Yapboz',
        drawing: 'Resim malzemesi',
        crafts: 'El işi malzemesi',
        reading: 'Kitap',
        gaming: 'Oyun konsolu',
        cycling: 'Bisiklet',
        soccer: 'Futbol topu',
        skating: 'Paten',
        swimming: 'Yüzme malzemesi',
        dance: 'Dans dersi',
        'music-lesson': 'Müzik dersi',
        guitar: 'Gitar',
        piano: 'Piyano',
        drums: 'Davul seti',
        unicorn: 'Tek boynuzlu at',
        dino: 'Dinozor',
        rocket: 'Roket',
        bear: 'Ayıcık',
        rabbit: 'Tavşan',
        cat: 'Kedi',
        dolphin: 'Yunus',
        butterfly: 'Kelebek',
        rainbow: 'Gökkuşağı',
        sunflower: 'Çiçekler',
        'ice-cream': 'Dondurma',
        pizza: 'Pizza',
        popcorn: 'Patlamış mısır',
        cinema: 'Sinemaya gitmek',
        zoo: 'Hayvanat bahçesi',
        museum: 'Müzeye gitmek',
        camping: 'Kamp',
        sleepover: 'Pijama partisi',
        party: 'Parti',
        trophy: 'Kupa',
    },
    kiosk: {
        wishesEntry: 'Dilekler',
        messagesEntry: 'Mesajlar',
        myWishes: 'Dileklerim',
        newWish: 'Yeni dilek',
        pickPicture: 'Bir resim seç',
        howMuch: 'Ne kadar istiyorsun?',
        addToList: 'Listeme ekle',
        removeAsk: 'Kaldıralım mı?',
        wishAdded: 'Listende!',
        /** Rustig, buiten het thema Kinderen. */
        wishAddedCalm: 'Listende',
        noWishes: 'Henüz dilek yok',
        noWishesBody: 'Artıya dokun ve bir resim seç.',
        conversations: 'Sohbetler',
        unread: { one: '{count} yeni', other: '{count} yeni' },
        wishRemoved: '{title} kaldırıldı',
        messageSent: 'Gönderildi',
        oops: 'Hay aksi',
        typeOwn: 'Kendin yaz',
        typeLabel: 'Mesajın',
        typePlaceholder: 'Ne söylemek istiyorsun?',
        send: 'Gönder',
        closeTyping: 'Yazmayı bitir',
        notYou: 'Başkası mı?',
        newMessages: 'Yeni mesajlar',
        alreadyOnList: 'Zaten listende!',
        alreadyOnListCalm: 'Zaten listende',
        morePictures: 'Daha fazla resim',
        morePhrases: 'Daha fazla cümle',
    },
};
//# sourceMappingURL=family.tr.js.map